<template>
  <div class="news">
    <div class="container">
      <div class="information" v-for="item in articleList" :key="item.id">
        <el-image class="information_left" :src="item.coverImage"></el-image>
        <div class="information_right">
<!--          <span class="time">{{ item.createTime }}</span>-->
          <span class="title">{{ item.title }}</span>
          <span class="content">{{ item.content }}</span>
          <el-button type="primary" class="detail_btn" @click="toDetails(item.id)">详情 Details</el-button>
        </div>
      </div>
      <section class="container">
        <TablePage ref="list" @page-change="getArticleList" :total="total" :pageSizeNum="3"> </TablePage>
      </section>
    </div>
    <NewsDialog :visible.sync="newsVisible" title="" :newsDialogData="newsDialogData"></NewsDialog>
  </div>
</template>

<script>
import TablePage from "@/components/base/TablePage";
import NewsDialog from "./components/NewsDialog";
import {getInformationColumn, getInformationColumnDetail, getInformationColumnList} from "@/api/api";
export default {
  name: "news",
  components: { TablePage, NewsDialog },
  data() {
    return {
      articleList: [],
      newsDialogData: {},
      total: 0,
      newsVisible: false,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    toDetails(val) {
      this.getArticleDetail(val);
      this.newsVisible = true;
    },
    removeTAG(str) {
      return str.replace(/<[^>]+>/g, "").replace(/&nbsp;/g,"");
    },
    async getArticleList(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getInformationColumnList(params);
        this.articleList = (list || []).map((item) => {
          item.content = this.removeTAG(item.content);
          // console.log('item.content',item.content)
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    async getArticleDetail(id) {
      const params = {
        id: id,
      };
      try {
        let { data } = await this.$api.getInformationColumnDetail(params);
        let newsDialogData = data || {};
        newsDialogData.content = newsDialogData.content.replace(/img/g, 'img class="descClauseImg"');
        newsDialogData.imgList = (newsDialogData.coverImage || "").split(",");
        this.newsDialogData = newsDialogData;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  margin-top: 30px;
}
.information {
  padding: 30px 0;
  display: flex;
  border-bottom: 1px solid #f0f0f0;
}
.information_left {
  width: 300px;
  height: 234px;
}
.information_right {
  width: 820px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  word-wrap: break-word;
  white-space: normal;
  margin-left: 40px;
}
.time {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.title {
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: bold;
  color: #333333;
}
.content {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1.5rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.detail_btn {
  width: 152px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #333333;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
</style>
